import actions from '../../actionTypes';

export default groupId => {
  return {
    type: actions.DELETE_GROUP,
    groupId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/groups/actions/deleteGroup.js